import chineseMessages from '@haxqer/ra-language-chinese'
import { TranslationMessages } from 'react-admin'

const customChineseMessages: TranslationMessages = {
  ...chineseMessages,
  ra: {
    ...chineseMessages.ra,
    action: {
      ...chineseMessages.ra?.action,
      clear: '清除',
      reset: '重置',
      search_columns: '搜索列',
      select_all_button: '全选',
    },
    auth: {
      ...chineseMessages.ra?.auth,
      email: '邮箱',
    },
    configurable: {
      customize: (chineseMessages.ra as any)?.configurable?.customize ?? '自定义',
      configureMode: (chineseMessages.ra as any)?.configurable?.configureMode ?? '配置此页面',
      inspector: {
        title: '检查器',
        content: '将鼠标悬停在 UI 元素上即可配置',
        reset: '重置',
        hideAll: '全部隐藏',
        showAll: '全部显示',
      },
      Datagrid: (chineseMessages.ra as any)?.configurable?.Datagrid ?? {
        title: '数据表格',
        unlabeled: '未标记列 #%{column}',
      },
      SimpleForm: (chineseMessages.ra as any)?.configurable?.SimpleForm ?? {
        title: '表单',
        unlabeled: '未标记输入 #%{input}',
      },
      SimpleList: (chineseMessages.ra as any)?.configurable?.SimpleList ?? {
        title: '列表',
        primaryText: '主文本',
        secondaryText: '次文本',
        tertiaryText: '第三文本',
      },
    },
    message: {
      ...chineseMessages.ra?.message,
      access_denied: '您没有访问此页面的权限',
      authentication_error: '认证服务器返回错误,无法验证您的凭据。',
      placeholder_data_warning: '网络问题：数据刷新失败。',
      select_all_limit_reached: '元素过多无法全部选中。仅选中前 %{max} 个元素。',
    },
    navigation: {
      ...chineseMessages.ra?.navigation,
      clear_filters: '清除筛选',
      no_filtered_results: '当前筛选下未找到 %{name}。',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} 共超过 %{offsetEnd}',
    },
    notification: {
      ...chineseMessages.ra?.notification,
      offline: '无网络连接，无法获取数据。',
    },
    page: {
      ...chineseMessages.ra?.page,
      access_denied: '访问被拒绝',
      authentication_error: '认证错误',
    },
    validation: {
      ...chineseMessages.ra?.validation,
      unique: '必须唯一',
    },
  },
  pos: {
    app_title: 'Adapet 兽医门户',
    login: {
      title: '登录',
      subtitle: 'Adapet Medical 兽医门户',
      forgot_password: '忘记密码？',
      no_account: '还没有账号？',
      sign_up: '注册',
      or: '或',
      continue_microsoft: '使用 Microsoft 继续',
    },
    shared_with_me: {
      load_failed: '加载共享数据失败，请稍后重试。',
      empty_title: '尚无共享给您的宠物',
      empty_subtitle: '当其他兽医与您共享患者病例时，将显示在此处。',
      shared_by: '共享自 %{name}',
      all_pets: '所有宠物',
      specific_pets: '%{count} 只指定宠物',
      you_can: '您可以：%{permissions}',
      shared_at: '共享时间：%{date}',
      expires_at: '过期时间：%{date}',
      shared_pets_label: '共享宠物：',
      view_pet: '查看宠物',
      pet_meta: '%{species} • 客户：%{owner}',
      all_pets_message:
        '您可以访问 %{name} 的所有客户宠物。共享的宠物将以共享标识显示在您的常规宠物列表中。',
      permissions: {
        view_metrics: '查看指标',
        view_emrs: '查看病历',
        add_activities: '添加活动',
        add_emr_notes: '添加笔记',
      },
    },
    consent: {
      loading: '正在加载同意请求...',
      title: '小组成员邀请',
      title_with_count: '小组成员邀请 (%{count})',
      no_pending: '您没有待处理的小组成员邀请。',
      pending_warning: '您有待处理的小组成员邀请，需要您的同意。',
      pending_chip: '待处理',
      accept: '接受',
      decline: '拒绝',
      cancel: '取消',
      invited_by: '邀请人：%{name} (%{email})',
      invited_on: '邀请日期：%{date}',
      accept_dialog_title: '接受小组成员邀请',
      decline_dialog_title: '拒绝小组成员邀请',
      accept_question: '您想加入"%{group}"小组吗？',
      decline_question: '您确定要拒绝加入"%{group}"小组的邀请吗？',
      accept_warning:
        '接受后，您将与此小组的授权成员共享患者数据，并可访问他们共享的患者以进行协作监测。',
      notes_label: '备注（可选）',
      accept_notes_placeholder: '添加任何关于加入此小组的备注...',
      decline_notes_placeholder: '添加拒绝原因（可选）...',
      load_failed: '加载同意请求失败',
      retry: '重试',
      update_failed: '更新同意状态失败',
    },
    auth: {
      login: {
        email_not_verified: '请先验证您的邮箱后再登录。请查看收件箱中的验证链接。',
        invalid_credentials: '邮箱或密码不正确。',
        account_locked: '由于多次登录失败，您的账户已暂时锁定。请稍后重试。',
        role_not_allowed: '此账户无权访问兽医门户。宠物主人请使用 Adapet Medical 手机应用。',
        generic_error: '登录失败，请重试。',
        oauth_failed: '使用该方式登录失败。请重试，或使用邮箱和密码登录。',
        sso_failed: '无法完成单点登录。请从原应用重新开始，或使用邮箱和密码登录。',
      },
      verify_email: {
        verifying_title: '正在验证您的邮箱…',
        verifying_body: '正在验证您的邮箱地址，请稍候。',
        success_title: '邮箱已验证',
        failed_title: '验证失败',
        success_message: '您的邮箱已验证，正在跳转到登录页…',
        invalid_message: '此验证链接无效或已过期。',
        contact_support: '如果问题持续存在，请联系客服。',
        go_to_login: '前往登录',
      },
      forgot_password: {
        title: '忘记密码',
        description: '输入您的邮箱地址，我们将向您发送重置密码的链接。',
        email_label: '邮箱地址',
        sending: '发送中...',
        send_button: '发送重置邮件',
        back_to_login: '返回登录',
        success: '密码重置邮件已发送！请查看您的收件箱并按照说明操作。',
        email_required: '请输入邮箱地址',
        send_failed: '发送重置邮件失败',
        connection_error: '无法连接到服务器，请稍后重试。',
      },
      reset_password: {
        title: '重置密码',
        invalid_link_title: '重置链接无效',
        invalid_link_message: '此密码重置链接无效或已过期。',
        request_new: '请求新的重置链接',
        new_password_label: '新密码',
        confirm_password_label: '确认新密码',
        resetting: '重置中...',
        reset_button: '重置密码',
        success: '密码重置成功！正在跳转到登录页面...',
        invalid_request: '无效请求，请重新请求密码重置链接。',
        reset_failed: '密码重置失败，链接可能已过期。',
        network_error: '网络错误，请重试。',
        password_required: '请输入密码',
        passwords_dont_match: '两次输入的密码不一致',
      },
    },
    search: '搜索',
    configuration: '配置',
    language: '语言',
    action: {},
    theme: {
      name: '主题',
      light: '浅色',
      dark: '深色',
    },
    dashboard: {
      title: '仪表板',
      welcome_subtitle: '欢迎回到 Adapet 兽医门户。以下是今日动态。',
      active_patient_context: '当前患者：',
      pet_id_label: '宠物 ID：%{id}',
      no_patient_selected: '未选择患者。请选择一位患者以查看监测数据。',
      pets_section: '宠物',
      devices_section: '设备',
      monthly_revenue: '月度监测活动',
      month_history: '30天监测活动',
      new_orders: '新设备订单',
      pending_emrs: '待处理 EMRs',
      all_emrs: '查看所有 EMRs',
      new_customers: '新客户',
      all_customers: '查看所有客户',
      pending_orders: '待处理设备订单',
      current_selected_pet: '当前选择的宠物：',
      recently_updated: '最近更新',
      generate_report: '生成报告',
      glucose_report: '血糖报告',
      glucose_trend: '血糖趋势',
      daily_tir: '每日 TIR',
      daily_trends_and_activities: '每日血糖趋势与活动',
      simple_view: '简洁视图',
      full_report: '完整报告',
      print_report: '打印报告',
      no_data: 'N/A',
      activity_logs: '活动日志',
      log_event_prompt: '点击 + 记录事件来跟踪胰岛素、食物或运动活动',
      date_range_navigation: '日期范围导航',
      clinical_notes: '临床笔记',
      add_note_description: '为该宠物添加笔记，将包含在PDF报告中。',
      portal_view: '门户视图',
      no_device_selected: '该患者没有可用的设备',
      no_devices: '未找到此患者的设备',
      search_pets: '按客户、患者名称、患者ID、医院名称或设备ID搜索...',
      error_loading_data: '加载数据出错',
      no_data_available: '无可用数据',
      order: {
        items: '由 %{customer_name} 订购，1 项 |||| 由 %{customer_name} 订购，%{nb_items} 项',
      },
      welcome: {
        title: '欢迎使用 Adapet 兽医门户',
        subtitle: '查看患者监测数据、血糖趋势及临床动态。',
        ra_button: '打开管理资源',
        demo_button: '查看产品文档',
      },
      clinical: {
        title: '仪表盘',
        stat: {
          active_cgm_title: '活跃 CGM 患者',
          active_cgm_subtitle: '正在使用活跃传感器',
          needs_review_title: '需复查的患者',
          needs_review_subtitle: '血糖规律或数据缺口可能需要复查',
          pending_confirmation_title: '待客户确认',
          pending_confirmation_subtitle: '账户尚未确认',
          recent_alerts_title: '近期血糖警报',
          recent_alerts_subtitle: '最近 24 小时',
          follow_up_title: '今日待随访',
          follow_up_subtitle: '今日已安排',
        },
        active_cgm_patients: '活跃 CGM 患者',
        search_placeholder: '按患者、客户、诊所、设备 ID 搜索…',
        filter: '筛选',
        hidden_patients: '已隐藏的患者',
        todays_priority: '今日优先事项',
        no_priority: '暂无高优先级患者。',
        pending_setup: '待设置 / 确认',
        recent_activity: '近期临床动态',
        no_recent_activity: '暂无近期临床动态。',
        loading: '正在加载临床仪表盘…',
        no_match: '没有符合搜索或筛选条件的患者。',
        no_email: '无邮箱',
        no_reading: '无血糖读数',
        no_data: '无数据',
        review_trend: '查看趋势',
        add_note: '添加备注',
        resend_email: '重新发送邮件',
        resend: '重新发送',
        view: '查看',
        edit: '编辑',
        client_prefix: '客户：',
        updated_prefix: '更新于 %{time}',
        species_fallback: '患者',
        // Relative timestamps on the patient list and the activity feed.
        time: {
          just_now: '刚刚',
          minutes_ago: '%{count} 分钟前',
          hours_ago: '%{count} 小时前',
          yesterday: '昨天',
          days_ago: '%{count} 天前',
          recently: '最近',
        },
        pet_fallback: '患者 #%{id}',
        breed_fallback: '混种',
        table: {
          priority: '优先级',
          patient: '患者',
          species_breed: '物种 / 品种',
          cgm_status: 'CGM 状态',
          last_reading: '最近读数',
          alert_status: '警报状态',
          last_updated: '最近更新',
          action: '操作',
          pet: '患者',
          client: '客户',
          email: '邮箱',
          status: '状态',
          created: '创建时间',
        },
        filters: {
          all: '全部患者',
          'active-cgm': '活跃 CGM',
          'needs-review': '需复查',
          'recent-alerts': '近期血糖警报',
          hypoglycemia: '低血糖警报',
          hyperglycemia: '高血糖警报',
          'pending-confirmation': '待确认',
          'follow-up': '待随访',
          'my-patients': '仅我的患者',
        },
        status: {
          Stable: '稳定',
          'Needs Review': '需复查',
          'Hypoglycemia Alert': '低血糖警报',
          'Hyperglycemia Alert': '高血糖警报',
          'Stale Reading': '读数过时',
          'Data Gap': '数据缺口',
          'Sensor Issue': '传感器异常',
          'No Active Device': '无活跃设备',
          'Pending Client Confirmation': '待客户确认',
          'Follow-up Due': '待随访',
        },
        // 仪表板的列表请求在服务端被截断（DEVICES_MAX_LIMIT / METRICS_MAX_LIMIT），
        // 此前仅在服务端记录日志，因此全部车队视图会静默地只显示 1592 个传感器中的 1000 个。
        truncated: {
          title: '当前视图仅显示部分数据',
          detail: '已加载 %{total} 条%{resource}中的 %{loaded} 条。',
          pets: '患者',
          devices: '传感器',
          consequence:
            '不在此范围内的患者可能显示"无设备"或过时的 CGM 状态。请缩小查看范围以查看这些患者。',
        },
        load_error: {
          title: '部分患者数据未能加载',
          detail:
            '下方的状态、读数和近期活动可能不完整，患者可能因此显示"无设备"或不显示血糖警报。请刷新页面重试。',
        },
        cgm: {
          Active: '活跃',
          // 传感器停止上报超过 INACTIVE_SENSOR_MS：已脱落或本次佩戴结束
          Inactive: '未在用',
          Pending: '待处理',
          'No Device': '无设备',
        },
        activity: {
          new_reading: '收到新的血糖读数',
          pending_confirmation: '待客户确认',
          vet_note: '已添加兽医备注',
          hypoglycemia_detected: '记录到低血糖警报',
          hyperglycemia_detected: '记录到高血糖警报',
          client_added: '客户添加了%{type}',
        },
      },
    },
    whats_new: {
      title: '更新内容',
      page_title: 'VetPo 更新内容',
      dialog_title: 'VetPo 有哪些新变化',
      help_desc: '用通俗的语言说明最近几次门户更新改了什么。',
      released_on: '发布于 %{date}',
      got_it: '知道了',
      see_all: '查看全部更新',
      dismiss: '关闭',
      back_to_help: '返回帮助',
      empty: '尚未发布任何更新说明。',
    },
    help: {
      menu_title: '帮助与支持',
      page_title: 'VetPo 帮助中心',
      title: '帮助与支持',
      welcome_message:
        '欢迎来到 Adapet 帮助中心。查找指南、教程和支持资源，帮助您充分利用血糖监测系统。',
      current_language: '当前语言',
      user_guides: '用户指南',
      user_guides_desc: '全面的指南，帮助您有效地导航和使用 Adapet 兽医门户。',
      quick_start: '快速入门指南',
      quick_start_desc: '开始了解VetPo系统基础和导航。',
      features_guide: '功能指南',
      features_guide_desc: 'VetPo所有功能和能力的完整概述。',
      reading_tables: '读取表格',
      reading_tables_desc: '学习如何解释数据表格和质量指标。',
      understanding_charts: '理解图表',
      understanding_charts_desc: '掌握血糖趋势图表和分析可视化。',
      faq: '常见问题解答',
      faq_desc: '常见问题和故障排除解决方案。',
      open_guide: '打开指南',
      quick_reference: '快速参考',
      quick_ref: {
        navigation: '基本导航',
        navigation_desc: '使用侧边栏菜单访问不同部分',
        pet_selection: '宠物选择',
        pet_selection_desc: '在控制面板中点击患者的“查看”，打开其血糖详情',
        glucose_monitoring: '血糖监测',
        glucose_monitoring_desc: '在图表中查看实时数据和趋势',
      },
      support_contact: '支持与联系',
      support_desc: '获取 Adapet 兽医门户的产品与技术支持。',
      support: {
        email: '邮件支持',
        email_desc: 'support@adapetmedical.com - 24小时内回复',
        chat: '在线聊天',
        chat_desc: '工作时间内可用',
        phone: '电话支持',
        phone_desc: '1-888-444-2618 - 紧急问题电话支持',
        chat_available: '在线聊天可用！在屏幕右下角查找聊天图标。',
      },
      contact: '联系',
      emergency_notice_title: '紧急提示',
      emergency_notice_desc:
        '对于直接的兽医紧急情况，始终优先进行直接临床评估而非系统数据。VetPo提供监测工具，但不能替代专业的兽医判断。',
    },
    users: {
      access_denied: '访问被拒绝。仅限站点管理员。',
      col_role: '角色',
      col_clinic: '诊所',
      col_actions: '操作',
      promote_success: '%{email} 已提升为组管理员',
      promote_confirm: '将 %{email} 提升为组管理员 (vetadmin)？',
      promote_failed: '用户提升失败',
      manage_users: '管理用户',
      promote_button: '提升为组管理员',
      role_vet: '兽医',
      role_vetadmin: '组管理员',
      role_admin: '系统管理员',
      role_siteadmin: '站点管理员',
      role_cms: '内容管理员',
      role_user: '客户',
      current_language: '当前语言',
      user_guides: '用户指南',
      user_guides_desc: '全面的指南，帮助您有效地导航和使用VetPo。',
      quick_start: '快速入门指南',
      quick_start_desc: '开始了解VetPo系统基础和导航。',
      features_guide: '功能指南',
      features_guide_desc: 'VetPo所有功能和能力的完整概述。',
      reading_tables: '读取表格',
      reading_tables_desc: '学习如何解释数据表格和质量指标。',
      understanding_charts: '理解图表',
      understanding_charts_desc: '掌握血糖趋势图表和分析可视化。',
      faq: '常见问题解答',
      faq_desc: '常见问题和故障排除解决方案。',
      open_guide: '打开指南',
      quick_reference: '快速参考',
      quick_ref: {
        navigation: '基本导航',
        navigation_desc: '使用侧边栏菜单访问不同部分',
        pet_selection: '宠物选择',
        pet_selection_desc: '在控制面板中点击患者的“查看”，打开其血糖详情',
        glucose_monitoring: '血糖监测',
        glucose_monitoring_desc: '在图表中查看实时数据和趋势',
      },
      support_contact: '支持与联系',
      support_desc: '在您最需要的时候获得帮助。',
      support: {
        email: '邮件支持',
        email_desc: 'support@adapetmedical.com - 24小时内回复',
        chat: '在线聊天',
        chat_desc: '工作时间内可用',
        phone: '电话支持',
        phone_desc: '1-888-444-2618 - 紧急问题支持',
        chat_available: '在线聊天可用！在屏幕右下角查找聊天图标。',
      },
      contact: '联系',
      emergency_notice_title: '紧急提示',
      emergency_notice_desc:
        '对于直接的兽医紧急情况，始终优先进行直接临床评估而非系统数据。VetPo提供监测工具，但不能替代专业的兽医判断。',
    },
    chat: {
      title: '在线支持',
      welcome_message:
        '您好！我可以为您提供什么帮助？我可以协助解答 Adapet 兽医门户功能、血糖监测或技术问题。',
      input_placeholder: '输入您的消息...',
      send: '发送',
      typing: '客服正在输入',
      status_online: '在线',
      status_offline: '离线',
      powered_by: '由 Adapet 支持服务提供',
      error_general: '抱歉，遇到了错误。请重试。',
      error_network: '网络错误。请检查网络连接后重试。',
      minimize: '最小化',
      close: '关闭聊天',
      unread_indicator: '新消息',
    },
    client_profile: {
      edit_client: '编辑客户',
      dialog_title: '编辑客户信息',
      save: '保存',
      saved: '客户信息已更新。',
      save_error: '无法更新客户信息，请重试。',
      not_allowed: '您没有权限编辑此客户。',
      name_too_short: '客户姓名至少需要2个字符。',
      read_only_hint: '只有与该客户关联的诊所可以编辑其信息。',
    },
    pet_edit: {
      some_fields_read_only: '部分字段对您的角色为只读，所做更改不会保存。',
      all_fields_read_only: '该宠物对您的角色为只读，所做更改不会保存。',
      pet_information: '宠物信息',
      basic_details_readonly: '基本宠物信息（只读）',
      basic_details_editable: '患者及其客户的基本信息。',
      owner_name: '客户姓名',
      editable_fields: '体测数据',
      vet_modifiable_fields: '在诊所测量记录的身高和体重。',
      chronic_care: '慢性病管理档案',
      chronic_care_hint:
        '由兽医管理的临床字段。这些字段用于糖尿病血糖目标范围以及 AdapetApp 的热量平衡显示。',
      weight_kg_hint: '以千克为单位的数值体重。若为空，将自动从文本体重字段填充。',
      birth_date_hint: '日历日期。若为空，将回退使用出生日期。',
      kcal_override_hint: '设置后，将替代 RER × 活动系数的估算值作为每日能量目标。',
      auto_save: {
        saving: '保存中...',
        saved: '宠物信息已保存',
        error: '保存宠物信息失败',
        unsaved_changes: '未保存的更改',
        last_saved: '上次保存于 %{time}',
      },
    },
    alert_rules: {
      // Toasts from the rules editor (messageArgs: rule = translated rule name).
      toast: {
        already_exists: '%{rule}已存在',
        update_not_found: '未找到要更新的现有规则 %{rule}',
        update_failed: '更新现有规则 %{rule} 失败',
        permission_denied: '权限不足：无法保存警报规则。请检查您的访问权限。',
        save_rule_failed: '保存 %{rule} 失败：%{error}',
        saved_partial: '已保存 %{saved}/%{total} 条规则，部分规则保存失败。',
        save_failed_details: '保存警报规则失败。请查看浏览器控制台了解详情。',
        save_failed: '保存警报规则失败',
      },
      per_15min: '%{unit}/15 分钟',
      delete_failed: '无法删除该规则，它仍处于启用状态。请重试。',
      title: '血糖警报规则',
      glucose_range: '血糖范围',
      copy: {
        prompt:
          '这看起来是 "%{name}" 的新传感器档案，该档案已有 %{count} 条警报规则。是否复制其阈值？',
        review_hint: '请在下方检查并调整复制的阈值——更改会自动保存。',
        action: '查看并复制',
        copied: '阈值已复制——请在下方检查数值。',
        none_found: '在之前的档案中未找到警报阈值。',
        failed: '无法从之前的档案复制阈值。',
      },
      unsaved_changes: '未保存的更改',
      configuration_desc: '为该患者配置血糖监测阈值和警报条件',
      configuration_info:
        '设定此患者的自定义血糖阈值。血糖范围将根据所配置的阈值计算得出。当血糖读数低于或高于这些阈值时，规则将触发警报。',
      add_rule_tooltip: '添加新的警报规则',
      save_rules: '保存规则',
      saving: '保存中...',
      loading: '正在加载警报规则...',
      no_rules_configured: '未配置警报规则。点击"添加规则"为此患者创建血糖监测规则。',
      rule_types: {
        critical_hypoglycemia: '危急低血糖',
        warning_hypoglycemia: '警告低血糖',
        critical_hyperglycemia: '危急高血糖',
        warning_hyperglycemia: '警告高血糖',
        rapid_drop: '快速下降',
        dawn_pattern: '晨间血糖模式',
        somogyi_pattern: '可能的反跳模式',
        postprandial_spikes: '餐后血糖峰值',
      },
      thresholds: {
        critical_threshold: '危急阈值',
        warning_threshold: '警告阈值',
        hyperglycemia_threshold: '高血糖阈值',
        severe_hyperglycemia_threshold: '严重高血糖阈值',
        somogyi_rebound_threshold: 'Somogyi反弹阈值',
        dawn_elevation_threshold: '黎明升高阈值',
        drop_threshold: '下降阈值',
        analysis_window: '分析窗口（小时）',
        postprandial_spike_threshold: '餐后峰值阈值',
        severe_spike_threshold: '严重峰值阈值',
        postprandial_window_hours: '餐后监测窗口（小时）',
        pre_meal_window_hours: '餐前基线窗口（小时）',
      },
      fields: {
        rule_type: '规则类型',
        unit: '单位',
        trigger_count: '触发次数',
        trigger_count_helper: '只读使用计数',
        notes: '备注',
        notes_placeholder: '关于此规则的简要描述或备注',
        active: '激活',
        active_status: '激活',
        inactive_status: '未激活',
        email_notifications: '邮件通知',
        sms_notifications: '短信通知',
      },
      notification_settings: '通知设置',
      delete_rule_tooltip: '删除此规则',
      add_rule: '添加规则',
      load_failed: '无法加载该患者的警报规则。加载成功前不会显示或保存任何内容。',
      retry: '重试',
      saving_previous: '正在保存该患者之前的更改…您可以离开此页面，保存会继续进行。',
      unsaved_invalid: '%{name} 的部分警报阈值无效，未被保存。',
      unsaved_failed: '%{name} 的部分警报阈值未能保存。',
      save: '保存',
      auto_saving: '自动保存中...',
      all_rule_types_added: '所有规则类型已添加',
      help_text: {
        critical_hypoglycemia: '当血糖降至此阈值以下时触发危急警报。建议由兽医及时复核。',
        warning_hypoglycemia: '当血糖降至此阈值以下时触发警告警报。需要监测。',
        critical_hyperglycemia: '当血糖升至此阈值以上时触发危急警报。极高读数可能需要由兽医复核。',
        warning_hyperglycemia: '当血糖升至此阈值以上时触发警告警报。需要监测。',
        rapid_drop:
          '当血糖按指定速率随时间下降时触发警报。使用快速下降阈值进行检测，警告阈值进行低血糖监测。',
        dawn_pattern: '根据指定时间窗口标记晨间血糖升高模式。',
        somogyi_pattern: '标记低血糖发作后可能出现的反跳模式。需要分析窗口进行模式复核。',
        postprandial_spikes: '通过比较餐后血糖与餐前基线来标记餐后血糖峰值。',
      },
      somogyi_note:
        '注意：夜间低血糖阈值会自动从您现有的危急或警告低血糖规则中确定。请单独配置这些规则来设置夜间低阈值（晚上10点 - 早上6点）。',
      help_ranges: {
        critical_threshold: '范围：1.0-4.0 mmol/L。极低读数需由兽医及时复核。',
        warning_threshold: '范围：3.0-5.5 mmol/L。必须高于危急阈值。',
        hyperglycemia_threshold: '范围：8.0-25.0 mmol/L。应低于严重高血糖阈值。',
        severe_hyperglycemia_threshold: '范围：12.0-30.0 mmol/L。极高读数可能需由兽医及时复核。',
        somogyi_rebound_threshold: '范围：6.0-20.0 mmol/L。晨间反弹血糖水平。',
        dawn_elevation_threshold: '范围：5.0-15.0 mmol/L。晨间血糖升高阈值。',
        rapid_drop_threshold:
          '范围：1.0-5.0 mmol/L每15分钟。触发快速下降警报的血糖下降速率。算法分析过去30分钟的数据。',
        analysis_window: '范围：12-72小时。模式分析时间段。',
        postprandial_spike_threshold: '范围：3.0-10.0 mmol/L。高于基线的自定义峰值阈值。',
        severe_spike_threshold: '范围：5.0-15.0 mmol/L。严重峰值的更高阈值。',
        postprandial_window_hours: '范围：2.0-6.0小时。餐后监测峰值的时间窗口。',
        pre_meal_window_hours: '范围：0.5-3.0小时。餐前基线计算的时间窗口。',
      },
      metadata: {
        last_triggered: '最后触发',
        total_triggers: '总触发次数',
      },
      notifications: {
        saved_successfully: '警报规则保存成功',
        saved_locally: '警报规则已本地保存（服务器不可用）',
        could_not_load: '无法加载警报规则。使用默认值。',
      },
      validation: {
        required: '此字段为必填项',
        out_of_range: '数值必须在 {min} 到 {max} {unit} 之间',
        critical_threshold: '危急阈值超出允许范围。',
        warning_threshold: '警告阈值超出允许范围。',
        hyperglycemia_threshold: '高血糖阈值超出允许范围。',
        severe_hyperglycemia_threshold: '严重高血糖阈值超出允许范围。',
        somogyi_rebound_threshold: '可能的反跳阈值超出允许范围。',
        dawn_elevation_threshold: '黎明现象阈值必须在 5.0 到 15.0 mmol/L (90-270 mg/dL) 之间',
        rapid_drop_threshold: '快速下降阈值超出允许范围。',
        postprandial_spike_threshold: '餐后峰值阈值必须在 3.0 到 10.0 mmol/L (54-180 mg/dL) 之间',
        severe_spike_threshold: '严重峰值阈值超出允许范围。',
        postprandial_window_hours: '餐后时间窗口必须在 2.0 到 6.0 小时之间',
        pre_meal_window_hours: '餐前时间窗口必须在 0.5 到 3.0 小时之间',
        analysis_window: '分析时间窗口必须在 12 到 72 小时之间',
        cannot_save_with_errors: '无法保存：请先修正验证错误',
      },
    },
    alerts: {
      // Fallbacks for an alert that arrived without a title / message, and the toasts
      // shown when the vet jumps from an alert to the chart.
      fallback_title: '警报',
      fallback_message: '暂无详细信息',
      navigating_chart: '正在跳转到 %{time} 的血糖图表%{glucose}',
      navigating_patterns: '正在跳转到 %{date} 前后的血糖模式',
      navigating_overview: '正在跳转到患者概览（警报：%{title}）',
      not_available_for_role: '您的账号类型无法查看警报。请让兽医账号查看该患者的警报。',
      // 权限检查本身失败时显示；不要与上一行（关于账号类型的判断）混用。
      access_unknown: '暂时无法检查警报。这是连接问题，并非权限变更。',
      access_retry: '重试',
      fetch_error_auth: '警报更新已暂停，请刷新以重新登录。',
      fetch_error_unavailable: '警报服务暂不可用，当前显示最后一次已知状态。',
      title: 'AI 智能警报',
      total: '总计',
      no_alerts: '没有符合当前筛选条件的警报',
      alert_context: '警报上下文',
      recommendations: '复核备注',
      details: '详情',
      acknowledge: '确认',
      acknowledged: '已确认',
      active: '活跃',
      resolved: '已解决',
      dismissed: '已忽略',
      unacknowledged_count: '%{count} 条未确认',
      refresh_tooltip: '刷新警报',
      monitoring_issue: '警报监控问题',
      monitoring_issue_retry: '警报可能不是最新的。请刷新重试。',
      no_recent_alerts: '没有最近的警报',
      checking_interval: '每 %{minutes} 分钟检查一次警报',
      acknowledged_at: '已确认：%{time}',
      acknowledge_success: '警报已成功确认',
      acknowledge_failed: '确认警报失败',
      acknowledge_tooltip: '确认警报',
      mark_resolved: '标记为已解决',
      resolve_hint: '已查看并处理？可填写处理备注，然后标记为已解决。',
      resolve_notes_placeholder: '处理备注（可选）—— 例如：已调整胰岛素、无需进一步处理…',
      resolved_at: '已解决：%{time}',
      resolution_note: '备注：%{note}',
      show_resolved: '显示已解决的警报',
      hide_resolved: '隐藏已解决的警报',
      resolved_count: '%{count} 条已解决',
      all_resolved: '所有警报已解决',
      show_details: '显示详情',
      pet_alerts: '患者 %{petId} 的警报',
      all_pets: '所有患者',
      showing_count: '显示 %{shown} / %{total} 条警报',
      critical_require_attention: '%{count} 个危急警报需由兽医及时复核',
      critical_alerts_count: '%{count} 个危急警报',
      active_alerts_count: '%{count} 个活跃警报',
      navigate_cannot: '无法打开此警报，因为缺少患者ID。',
      filter: {
        severity: '严重程度',
        type: '类型',
        status: '状态',
        all: '全部',
        hypoglycemia: '低血糖',
        hyperglycemia: '高血糖',
        somogyi: 'Somogyi',
        trend: '趋势',
      },
      type: {
        hypoglycemia: '低血糖',
        critical_hypoglycemia: '危急低血糖',
        hyperglycemia: '高血糖',
        rapid_drop: '快速下降',
        pattern_detected: '模式',
        somogyi: '可能的反跳模式',
        sensor_failure: '传感器问题',
        trend: '趋势分析',
        trend_analysis: '趋势分析',
        system: '系统警报',
      },
      severity: {
        critical: '危急',
        high: '高',
        medium: '中',
        low: '低',
      },
      messages: {
        critical_attention: '危急警报需由兽医及时复核',
        hypoglycemia_detected: '记录到低于所选目标范围的低血糖读数',
        hyperglycemia_detected: '记录到高于目标范围的高血糖读数',
        somogyi_detected: '已标记可能的反跳模式，供兽医复核',
        trend_analysis_available: '新的血糖趋势分析可用',
      },
      configuration: {
        title: '警报配置',
        description: '配置警报阈值和趋势检测设置',
        hypoglycemia_section: '低血糖检测',
        hyperglycemia_section: '高血糖检测',
        somogyi_section: 'Somogyi现象检测',
        trend_analysis_section: '趋势分析',
        custom_rules_section: '自定义警报规则',
        save_config: '保存配置',
        reset_config: '重置为默认值',
        apply_preset: '应用预设',
        presets: {
          conservative: '保守型（高敏感度）',
          standard: '标准型（平衡）',
          aggressive: '激进型（低敏感度）',
        },
      },
      thresholds: {
        critical_threshold: '危急阈值',
        high_threshold: '高优先级阈值',
        medium_threshold: '中优先级阈值',
        confidence_threshold: '最低置信度',
        rebound_magnitude: '最小反弹幅度',
      },
      notifications: {
        email_sent: '邮件通知已发送',
        push_sent: '推送通知已发送',
        dashboard_updated: '仪表板通知已创建',
        vet_warning_sent: '兽医警报通知已发送',
        daily_report_sent: '日报已发送',
      },
      reports: {
        daily_report: '每日监测报告',
        summary_title: '警报摘要',
        glucose_summary: '血糖摘要',
        patterns_detected: '检测到的模式',
        ai_recommendations: '系统生成的洞察',
        report_period: '报告期间',
        total_readings: '总读数',
        time_in_range: '目标范围时间',
        episodes_count: '事件计数',
        generate_report: '生成报告',
        download_report: '下载报告',
        email_report: '邮件报告',
      },
    },
    menu: {
      section_patients: '客户',
      section_sharing: '协作',
      section_admin: '管理',
      clinic_teams: '诊所团队',
      clinic_team: '诊所团队',
      care_teams: '协作团队',
      all_teams_readonly: '所有团队（只读）',
      manage_users: '用户管理',
      my_account: '我的账户',
      register_owner: '添加新客户',
      owners_hint: '在您诊所登记的客户，以及每位客户名下的宠物。',
      register_owner_hint: '在客户就诊时为其创建账户——系统会向其发送邮件以设置密码并激活账户。',
      notes_hint: '您为患者撰写的 EMRs。',
      pet_shares_hint: '与其他兽医共享指定宠物（或您的所有宠物），并查看其他兽医共享给您的宠物。',
      clinic_team_hint: '管理诊所兽医：创建子账户并分配患者，使提醒发送给负责的兽医。',
      care_teams_hint:
        '诊所无需使用协作团队。在“诊所团队”中管理诊所兽医；如需与同事共享患者，请使用“宠物分享”。',
      sales: '销售',
      catalog: '目录',
      customers: '客户',
    },
    events: {
      review: {
        title: '为"%{product}"添加了备注',
      },
      order: {
        title: '订购了 1 件商品 |||| 订购了 %{smart_count} 件商品',
      },
    },
    export: {
      button: '导出',
      pdf: '导出为 PDF',
      image: '导出为图片',
    },
    glucose: {
      no_devices_found: '未找到该宠物的血糖监测设备。',
      trend_over_time: '血糖趋势变化',
      suspected_detachment: '疑似传感器脱落 — 数据已隐藏以待安全审查',
      statistics_range: '血糖统计和范围分析',
      time_in_range_analysis: '目标范围内时间分析',
      no_data_available: '无可用数据',
      event_band: '活动事件时间轴',
      view_day: '日',
      view_week: '周',
      view_month: '月',
      reset_view: '重置视图',
      reset_group: '重置分组',
      reset_selection: '重置选择',
      select_date: '选择日期',
      start_date: '开始日期',
      end_date: '结束日期',
      date_range: '日期区间',
      single_date: '单日',
      filter_date_range: '筛选日期范围',
      available_range: '可用范围',
      configure_target_range: '配置目标范围',
      target_range_save_failed: '目标范围保存失败——仍显示之前的范围。',
      show_activity_markers: '显示活动标记',
      hide_activity_markers: '隐藏活动标记',
      target_range_settings: '目标范围设置',
      target_low: '目标下限',
      target_high: '目标上限',
      current_unit: '当前单位',
      out_of_range: '超出范围',
      // 图表提示：绘制的点是滑动平均值，在血糖快速升降时会与单次读数不同。
      tooltip_avg: '平均',
      tooltip_reading: '读数',
      target_range_preview: '预览',
      species_fallback_notice:
        '尚未为 %{species} 定义参考范围，当前显示的是犬类默认值。如不适用，请为该患者单独设置范围。',
      loading_stats: '正在加载统计数据...',
      error_loading_stats: '加载统计数据时出错：',
      glucose_statistics: '血糖统计',
      image_export_requires: '图片导出当前不可用，请稍后重试。',
      days: '天',
      active_data_days: '有效数据天数',
      time_sensor_active: '传感器激活时间：',
      healthy_glucose_range: '所选目标范围：',
      below_range: '低于范围',
      above_range: '高于范围',
      average_glucose: '平均血糖',
      glucose_variability: '血糖变异性 (CV)',
      target_cv_message: '较低的血糖变异性可能有助于更好的血糖管理。请结合临床背景解读。',
      snapshot: '快照',
      libre_view: 'CGM 数据视图',
      average_glucose_caps: '平均血糖',
      percent_above_target: '% 高于目标',
      percent_in_target: '% 在目标范围',
      percent_below_target: '% 低于目标',
      low_glucose_events: '低血糖事件',
      average_duration: '平均持续时间：',
      carbs: '食物',
      carbohydrate_intake: '进食 / 食物摄入',
      insulin: '胰岛素',
      rapid_acting_insulin: '💉 速效胰岛素',
      long_acting_insulin: '长效胰岛素',
      total_daily_insulin: '📊 每日胰岛素总量',
      comments: '备注',
      min: '分钟',
      no_significant_issues: '在此期间未检测到明显问题。',
      loading_chart: '正在加载图表「…」',
      error_loading_chart: '加载图表时出错',
      time_in_range: '目标范围内时间',
      tir_distribution: '目标范围内时间分布',
      very_high: '极高',
      high: '高',
      target: '目标',
      low: '低',
      very_low: '极低',
      unit: 'mmol/L',
      hour_abbr: '小时',
      minute_abbr: '分',
      gram_abbr: 'g',
      unit_abbr: 'u',
      summary_report: '总结报告',
      report_period: '报告期间',
      report_generated: '报告生成时间',
      sensor_coverage: '传感器覆盖率',
      standard_deviation: '标准差 (SD)',
      effective_days: '有效天数',
      data_from_continuous_monitoring: '数据来自3分钟间隔的连续监测',
      range_distribution: 'TIR（目标范围时间）',
      ideal_targets: '参考目标',
      target_range_goal: '目标范围时间 ≥70%',
      low_glucose_goal: '低血糖暴露应由主诊兽医复查。',
      variability_goal: '变异系数 <36%',
      zoom_view: '缩放视图',
      zoom_chart: '缩放图表',
      close_zoom: '关闭缩放',
      detailed_view: '详细视图',
      summary_metrics: '摘要指标',
      show_events: '显示事件',
      hide_events: '隐藏事件',
      previous_day: '前一天',
      next_day: '后一天',
      duration_in_range: '范围内持续时间',
      zoom_tooltip: '点击放大查看这一天',
      before_device_start: '设备启动前',
      // Dashboard Part 2 - TIR Summary
      tir_statistics: 'TIR 统计',
      target_range: '目标范围',
      time_below_range: '低于目标范围时间 (TBR)',
      time_above_range: '高于目标范围时间 (TAR)',
      data_coverage: '数据覆盖率',
      readings: '读数',
      unit_mmol: 'mmol/L',
      time: '时间',
      glucose: '血糖',
      // Dashboard Part 7 - Low Glucose Events
      events: '事件',
      showing_events_below: '显示低于 %{threshold} %{unit} 的事件',
      // One episode = consecutive readings below threshold (not one per reading)
      episode_duration: '低于阈值 %{minutes} 分钟',
      episode_readings: '%{count} 个低于阈值的读数',
      no_low_events: '未检测到低血糖事件',
      no_low_events_description: '此期间没有低于 %{threshold} %{unit} 的读数',
      // Loading/error states
      loading_snapshot: '正在加载快照...',
      error_loading_snapshot: '加载快照出错',
      loading_range_bar: '正在加载范围条...',
      error_loading_range_bar: '加载范围条出错',
      loading_daily_tir: '正在加载每日TIR图表「…」',
      error_loading_daily_tir: '加载每日TIR图表出错',
      error_loading_trend: '加载图表出错',
      // Chart labels
      glucose_range_distribution: '血糖范围分布',
      time_format_note: '时间格式：HH:MM（基于3分钟读数间隔）',
      time_in_range_percent: '目标范围时间 (%)',
      glucose_overline: '血糖',
      target_range_label: '目标范围',
      no_data_text: '无数据',
      showing_devices: '显示来自 %{count} 个设备的数据',
      estimated: '（估计值）',
      y_position_estimated: '（Y轴位置为估计值）',
      view_all: '全部',
      // Auto-generated comments
      auto_comment_missing_insulin: '此期间有 %{days} 天没有记录胰岛素事件。',
      auto_comment_no_carbs: '此期间没有可用的进食记录。',
      auto_comment_high_low_events:
        '记录到大量低血糖读数（%{count} 次）。请复查胰岛素时间、进食记录、临床体征及确认性血糖检测。',
      // SummaryReportSection metric card labels
      avg_glucose_short: '平均血糖',
      cv_short: 'CV',
      std_dev_short: '标准差',
      coverage_suffix: '覆盖率',
      // GlucoseLineChart
      error_loading_chart_detail: '加载图表出错：%{error}',
      // Non-blocking indicator: the activities (insulin/food/exercise marker)
      // fetch failed while the glucose curve itself loaded fine.
      activity_markers_load_error: '无法加载活动标记',
      // Structured meal/insulin overlay markers (vic/vetpo#15)
      meal_status_normal: '正常进食',
      meal_status_less: '进食减少',
      meal_status_none: '未进食',
      insulin_dose_skipped: '未给药',
      insulin_dose_late_suffix: '（延迟）',
      insulin_units_abbr: '单位',
      insulin_exception_triggered: '已触发替代方案',
    },
    // Dashboard Part 3 - AGP
    agp: {
      time_of_day: '一天中的时间',
      title: '动态血糖谱',
      percentile_bands: '百分位带',
      median: '中位数 (50th)',
      percentile_5_95: '第 5–95 百分位',
      percentile_25_75: '第 25–75 百分位',
      hover_time: '时间',
      hover_median: '中位数',
    },
    // Dashboard Part 3 - Vet Internal Notes
    notes: {
      vet_notes: '兽医内部笔记',
      hospital_only_subtitle: '仅您的医院团队可见',
      add_note: '添加笔记',
      save_note: '保存笔记',
      enter_note: '输入您的临床笔记...',
      no_notes: '暂无笔记',
      add_first_note: '为此宠物添加第一条笔记',
      total_notes: '%{count} 条笔记',
      show_more: '显示更多',
      show_less: '收起',
      select_pet_first: '请先选择一只宠物以查看笔记',
      created_successfully: '笔记创建成功',
      error_creating: '创建笔记出错',
      include_in_report: '包含在PDF报告中',
      include_in_report_help: '取消勾选仅作为内部备注',
      internal_note: '内部',
    },
    // Dashboard Part 5 - Treatment Plan & Home Instructions (vic/vetpo#14)
    treatmentPlan: {
      title: '治疗方案与家庭护理说明',
      select_pet_first: '请先选择一只宠物以查看治疗方案',
      error_loading: '加载治疗方案出错',
      no_plan_yet: '暂无方案',
      create_plan: '创建方案',
      edit: '编辑',
      cancel: '取消',
      save_and_send: '保存并发送至主人应用',
      saved_successfully: '治疗方案已保存并发送至主人应用',
      error_saving: '保存治疗方案出错',
      insulin_plan_section: '胰岛素方案',
      insulin_product_label: '胰岛素产品',
      insulin_product_placeholder: '选择胰岛素产品',
      insulin_dose_label: '剂量（单位）',
      syringe_matched: '✓ 已自动匹配 %{syringe}',
      meal_plan_section: '喂食方案',
      add_time: '添加时间',
      remove_time: '移除时间',
      exceptions_section: '如果宠物食欲不振 → 设置说明',
      eating_less_label: '食欲减退时的说明',
      eating_less_placeholder: '给主人的说明...',
      not_eating_label: '未进食时的说明',
      not_eating_placeholder: '给主人的说明...',
      meal_reminders_label: '喂食提醒',
      home_instructions_section: '家庭护理说明',
      home_instructions_placeholder: '给主人应用的可选说明...',
      summary_insulin: '胰岛素：%{dose} 单位，%{product}',
      summary_insulin_no_dose: '胰岛素：%{product}',
      summary_no_insulin: '未设置胰岛素方案',
      summary_meal_times: '喂食时间：%{times}',
      summary_no_meal_times: '未设置喂食时间',
      summary_reminders_on: '喂食提醒：开启',
      summary_reminders_off: '喂食提醒：关闭',
      summary_home_instructions: '已设置家庭护理说明',
      last_updated: '最后更新于 %{date}',
    },
    // Dashboard Part 6 - Activities
    activities: {
      no_activities: '暂无活动记录',
    },
    // New-version prompts (banner + forced-reload dialog) and the section error fallback.
    app_update: {
      dialog_title: 'VetPo 需要更新',
      dialog_body:
        '此标签页运行的是 VetPo 的旧版本，必须重新加载才能正常工作。请立即完成或复制尚未保存的笔记。',
      reloading_in: '将在 %{seconds} 秒后自动重新加载…',
      reload_now: '立即重新加载',
      banner_message: 'VetPo 有新版本可用%{versions}。请刷新以更新。',
      refresh: '刷新',
    },
    error_boundary: {
      unable_to_load: '无法加载%{name}',
      content: '内容',
      render_error: '渲染此部分时出错。',
      try_again: '重试',
      names: {
        treatment_plan: '治疗方案',
        glucose_trend: '血糖趋势图',
        daily_tir: '每日目标范围内时间图',
        agp: 'AGP 图',
        daily_trends: '每日趋势',
        low_events: '低血糖事件',
      },
    },
    // Group membership list (a site-admin resource).
    group_members: {
      col_consent: '同意状态',
      status: {
        active: '活跃',
        invited: '已邀请',
        declined: '已拒绝',
        pending_consent: '待同意',
      },
      consent: { granted: '已同意', pending: '待处理', denied: '已拒绝' },
    },
    // Signed-out pages that render BEFORE <Admin> (App.tsx wraps them in I18nContextProvider).
    sso: {
      expired_title: '登录链接已过期',
      expired_body: '此登录链接无效或已过期。请返回 OPS 后重试。',
      go_to_sign_in: '前往登录',
      signing_in: '正在为您登录…',
    },
    team_invite: {
      title: '诊所团队邀请',
      clinic_fallback: '该诊所',
      invalid: '此邀请链接无效。',
      expired: '此邀请已过期。请联系诊所重新发送邀请。',
      go_to_sign_in: '前往登录',
      joined: '您已加入%{clinic}。正在跳转到门户…',
      intro:
        '%{clinic} 邀请您的账户（%{email}）加入其诊所团队。如果您接受，该诊所的主账户将能够查看您账户所管理的患者。您的登录名、密码和患者保持不变。',
      confirm_it_is_you: '请登录以确认是您本人：',
      email: '邮箱',
      password: '密码',
      accept: '接受并加入团队',
      decline: '拒绝',
      forgot_before: '忘记密码？请先打开',
      forgot_link: '密码重置页面',
      forgot_after: '，然后再使用此邀请链接。',
      sign_in_failed: '登录失败。请检查您的密码。',
      accept_failed: '无法接受邀请。',
      generic_error: '出现问题。请重试。',
    },
    // Tooltip on the app bar's loading indicator.
    app_bar: {
      last_updated: '最后更新：%{time}',
      no_data_loaded: '尚未加载数据',
    },
    weight_history: {
      title: '体重记录',
      current: '当前体重：%{weight}',
      recent_entries: '最近记录：',
      showing_latest: '显示最近 5 条，共 %{count} 条',
      series: '体重',
    },
    daily_trend: {
      avg: '日均值：',
      nadir: '日最低值：',
      peak: '日峰值：',
      readings: '%{count} 次读数',
    },
    // Chronic-state banner on the patient page. The title and the one-line clinical
    // summary are built from these (utils/tirStats.ts returns the key + numbers).
    glycemic_control: {
      based_on: '（基于 %{count} 次读数）',
      controlled: { title: '处于目标范围' },
      insufficient_data: { title: '数据不足，无法评估慢性状态' },
      uncontrolled_high: { title: '慢性高血糖' },
      uncontrolled_low: { title: '慢性低血糖' },
      mixed: { title: '控制不佳——血糖波动大' },
      summary: {
        controlled: '%{tir}% 的读数在目标范围内',
        insufficient_data: '读数不足，无法评估慢性状态',
        uncontrolled_high: '%{tar}% 的读数高于目标（持续高血糖）',
        uncontrolled_low: '%{tbr}% 的读数低于目标（持续低血糖——临床紧急）',
        mixed: '%{tar}% 高于目标且 %{tbr}% 低于目标——血糖波动大',
      },
    },
    common: {
      empty_data: '—',
      add_note: '添加病历',
      not_available: 'N/A',
      clear: '清除',
      unknown_error: '未知错误',
      close: '关闭',
      clear_search: '清除搜索',
      pet_fallback: '患者 #%{id}',
      group_fallback: '小组 %{id}',
      user_fallback: '用户 %{id}',
      vet_fallback: '兽医 #%{id}',
    },
    shares: {
      share_created_successfully: '分享创建成功',
      share_revoked_successfully: '分享已撤销',
      share_creation_failed: '部分分享创建失败。请重试。',
      unexpected_error: '发生意外错误',
      create: {
        title: '创建新分享',
        step_recipient: '选择接收方',
        step_pets: '选择宠物',
        step_permissions: '设置权限',
        how_to_share: '您希望如何分享？',
        share_registered: '与已注册的兽医分享',
        invite_email: '通过邮件邀请新兽医',
        select_veterinarians: '选择兽医',
        search_vets_placeholder: '按姓名或邮箱搜索（例如 "Dr. Smith" 或 "vet@clinic.com"）',
        vet_email_n: '兽医邮箱 %{n}',
        vet_email_placeholder: 'colleague@vetclinic.com',
        invite_helper: '我们将向他们发送加入平台的邀请',
        add_another_email: '添加另一个邮箱',
        what_to_share: '您希望分享什么？',
        all_pets: '我护理的所有患者',
        all_pets_hint: '分享您护理的所有当前及未来宠物',
        specific_pets: '仅特定宠物',
        specific_pets_hint: '精确选择要分享的宠物',
        select_pets: '选择宠物',
        select_pets_placeholder: '选择要分享的宠物',
        what_can_they_do: '他们可以做什么？',
        perm_view_metrics: '查看血糖指标和图表',
        perm_view_emrs: '查看电子病历',
        perm_add_activities: '添加活动（胰岛素、食物、运动）',
        perm_add_emr_notes: '为病历添加备注',
        note_label: '备注（可选）',
        note_placeholder: '添加关于分享原因的说明…',
        expiration_label: '过期日期（可选）',
        expiration_hint: '留空表示永不过期',
        cancel: '取消',
        back: '上一步',
        next: '下一步',
        send_invitations: '发送邀请',
        create_shares: '创建分享',
        error_no_vets: '请至少选择一位要分享的兽医',
        error_no_emails: '请至少输入一个要邀请的邮箱地址',
        created_success: '成功创建 %{smart_count} 个分享',
        create_failed: '创建分享失败：%{error}',
        partial_failure: '已创建 %{success} 个分享，但 %{failed} 个失败：%{error}',
      },
    },
    clinic_team: {
      title: '诊所团队',
      subtitle:
        '为每位兽医添加子账户，然后分配患者，使提醒发送给负责的兽医。子账户为可选项——您也可以继续用主账户管理全部事务。',
      add_button: '添加子账户',
      empty: '暂无团队成员。添加子账户即可开始。',
      list_unavailable: '添加子账户后，您的团队列表将显示在此处。',
      sub_account_notice:
        '只有诊所的主账户可以管理团队。如需添加、停用或重新分配兽医，请联系主账户。',
      col_name: '姓名',
      col_email: '邮箱',
      col_title: '职位',
      col_status: '状态',
      col_alerts: '提醒',
      col_actions: '操作',
      action_resend: '重新发送邀请',
      action_disable: '停用',
      action_enable: '启用',
      action_view_patients: '查看患者',
      invite_resent: '邀请已重新发送。',
      disabled: '子账户已停用。',
      disabled_reassign:
        '子账户已停用。仍有 %{count} 位患者分配给该账户——请将其重新分配给其他兽医。',
      enabled: '子账户已重新启用。',
      status_active: '已激活',
      status_pending_invitation: '待接受邀请',
      status_disabled: '已停用',
      status_removed: '已移除',
      alerts_on: '开',
      alerts_off: '关',
      add_title: '添加子账户',
      add_description:
        '创建一个兽医子账户。该兽医使用自己的邮箱登录，只能看到与其关联的患者——由其登记、由宠物主人选择或共享给其的患者——而非整个诊所的患者。分配患者只决定提醒发给谁，不改变谁能看到该患者。本主账户可以看到所有子账户可见的患者。',
      add_submit: '创建子账户',
      first_name: '名',
      last_name: '姓',
      email: '邮箱',
      professional_title: '职位 / 角色',
      phone: '电话（选填）',
      allow_alerts: '接收其患者的提醒邮件',
      send_invite: '立即发送激活邀请',
      created_invited: '子账户已创建——激活邀请已发送至 %{email}。',
      created_no_invite: '已为 %{email} 创建子账户。您可以稍后发送邀请。',
      assign_action: '分配兽医',
      reassign_action: '重新分配',
      assign_title: '分配负责兽医',
      assign_description:
        '勾选 %{pet} 的所有负责兽医。其提醒将发送给这些兽医；不勾选则该患者及其提醒仍归主账户。',
      assigned_vet: '负责兽医',
      unassigned: '未分配（主账户）',
      unassigned_short: '未分配',
      view_patients_chip: '负责兽医：%{vet}',
      no_assigned_patients: '该兽医名下暂无已分配的患者。可在患者行使用“分配兽医”指定负责人。',
      assign_to_me: '我（主账户）',
      assign_alerts_off: '已关闭邮件提醒',
      assign_muted_warning:
        '该兽医已关闭邮件提醒，因此该患者的提醒将不会发送给任何人——包括您和诊所。请为其开启提醒，或改选其他人。',
      assigned_vets: '负责兽医（可多选）',
      assign_muted_warning_for:
        '%{vet} 已关闭邮件提醒，因此不会收到该患者的提醒邮件。如果没有其他人接收提醒，则该患者的提醒将不会发送给任何人——包括您和诊所。请为其开启提醒，或改选其他人。',
      history_action: '历史记录',
      history_title: '分配历史',
      history_empty: '该患者暂无分配变更记录。',
      history_error: '无法加载分配历史。',
      history_when: '时间',
      history_by: '操作人',
      history_before: '变更前',
      history_after: '变更后',
      history_system: '系统',
      mute_label: '接收该患者的提醒邮件',
      mute_error: '无法更新您对该患者的提醒设置。',
      mute_silenced_warning:
        '该患者的提醒不会发送给任何人：所有接收人都已将其静音或关闭了邮件提醒。',
      assign_submit: '保存',
      assign_success: '患者分配已更新。',
      assign_not_in_team: '该兽医不属于您的诊所团队。',
      reminder_text: '有 %{count} 位患者尚未分配兽医。请分配，以便提醒发送给负责的兽医。',
      reminder_assign: '分配患者',
      reminder_later: '7 天后提醒',
      reminder_turn_off: '关闭提醒',
      reminder_turned_off: '已关闭患者分配提醒。',
      error_name_required: '姓名为必填项。',
      error_email_invalid: '请输入有效的邮箱地址。',
      error_email_exists: '该邮箱已存在账户。',
      invite_existing_prompt:
        '要邀请已有账号 %{email} 加入你的诊所团队吗?我们会向其发送邀请邮件——对方接受前不会有任何变化。',
      invite_existing_button: '发送团队邀请',
      invite_existing_sent: '邀请已发送至 %{email},对方接受后即加入你的团队。',
      error_generic: '无法创建子账户，请重试。',
      error_network: '网络错误。请检查网络连接后重试。',
    },
    pet_shares: {
      title: '宠物分享',
      subtitle:
        '与其他兽医分享患者记录，以便协作和提供更好的护理。您可以分享所有患者或选择特定病例。',
      edit_title: '编辑分享',
      edit_permissions: '权限',
      edit_expiry: '过期日期',
      edit_expiry_hint: '留空表示永不过期',
      edit_note: '备注',
      save: '保存更改',
      share_updated: '分享已更新',
      error_no_permissions: '请至少选择一项权限。',
      error_update_failed: '更新分享失败，请重试。',
      resend_invite: '重新发送邀请邮件',
      invite_resent: '邀请邮件已重新发送',
      copy_link: '复制邀请链接',
      link_copied: '邀请链接已复制到剪贴板',
      selected_count: '已选择 %{count} 项',
      revoke_selected: '撤销所选',
      bulk_revoked: '已撤销 %{count} 个分享',
      decline: '拒绝',
      decline_confirm: '拒绝此分享？您将失去这些宠物的访问权限，分享者会看到已拒绝状态。',
      share_declined: '已拒绝分享',
      revoke_confirm: '确定要撤销此分享吗？',
      revoke_share: '撤销分享',
      resend_failed: '重新发送邀请失败',
      bulk_revoke_confirm: '撤销所选的 %{count} 个分享？',
      bulk_revoke_failed: '批量撤销失败',
      revoke_failed: '撤销共享失败',
      // Per-row icon buttons: the id keeps otherwise identical buttons distinguishable.
      aria: {
        edit: '编辑共享 %{id}',
        resend: '重新发送邀请 %{id}',
        copy: '复制邀请链接 %{id}',
        revoke: '撤销共享 %{id}',
      },
      bulk_revoked_partial: '已撤销 %{count} 个分享（%{failed} 个失败）',
      decline_failed: '拒绝分享失败',
      load_failed: '加载分享失败，请稍后重试。',
      empty_title: '尚未创建分享',
      empty_subtitle: '创建您的第一个分享，与其他兽医协作。',
      create_share: '创建分享',
      tab_my_shared: '我分享的宠物',
      tab_shared_with_me: '分享给我的',
      status_active: '有效',
      status_pending: '邀请待处理',
      status_accepted: '已接受',
      status_declined: '已拒绝',
      chip_n_pets: '%{smart_count} 只宠物',
      permissions_summary: '权限：%{list}',
      created_label: '创建于：%{date}',
    },
    clinic_profile_prompt: {
      title: '完善您的诊所资料',
      subtitle:
        '您的账户尚未登记诊所信息。填写一次后，我们将开始为您的诊所进行审核——审核通过后可享受诊所价格并下单。',
      field_professional_title: '您的职称',
      professional_title_placeholder: '例如：DVM、诊所经理、兽医技师',
      field_practice_type: '诊所类型',
      practice_type_general: '全科诊所',
      practice_type_emergency: '急诊诊所',
      practice_type_specialty: '专科 / 转诊医院',
      practice_type_mobile: '流动诊所',
      practice_type_other: '其他',
      field_number_of_vets: '全职兽医人数',
      terms: '我确认本人为持证兽医专业人员，且以上信息属实。',
      submit: '提交审核',
      submitting: '提交中…',
      skip: '暂不填写',
      success: '感谢——您的诊所已提交审核。',
      error_generic: '无法提交诊所信息，请重试。',
      validation_required: '请填写所有必填项。',
      validation_terms: '请确认以上信息属实。',
    },
    onboarding_share: {
      title: '与同事共享您的诊疗工作',
      subtitle:
        '邀请同事协作管理您的患宠。他们将获得您所有宠物及客户的访问权限（包括以后添加的）。您可随时在“宠物分享”中撤销。',
      emails: '同事邮箱',
      emails_placeholder: 'colleague1@clinic.com, colleague2@clinic.com',
      hint: '多个邮箱请用逗号分隔。',
      submit: '发送邀请',
      skip: '暂时跳过',
      done: '已发送 %{count} 份邀请。',
      failed_list: '邀请失败：%{emails}',
      error_invalid: '请输入一个或多个有效的邮箱地址。',
    },
    register_owner: {
      title: '添加新客户',
      subtitle: '在门诊就诊时为客户创建账户。他们将收到一封邮件以设置密码并激活账户。',
      owner_name: '客户姓名',
      owner_email: '客户邮箱',
      owner_phone: '电话（可选）',
      add_pet: '同时登记宠物',
      pet_name: '宠物名称',
      pet_species: '物种',
      pet_breed: '品种',
      pet_dob: '出生日期',
      add_note: '记录本次就诊（临床笔记）',
      note_text: '就诊笔记',
      submit: '添加客户',
      success_title: '客户已登记',
      success_owner: '%{name}（%{email}）已成功登记。',
      success_pet: '宠物“%{name}”已添加到其账户。',
      email_sent: '账户激活邮件已发送至 %{email}。',
      email_failed: '账户已创建，但激活邮件发送失败。您可以稍后重新发送。',
      register_another: '添加另一位客户',
      view_owners: '查看客户列表',
      owner_exists: '该邮箱属于一个无法登记为客户的现有账户。',
      approval_title: '已请求客户审批',
      approval_body:
        '该邮箱已有AdaPet账户，因此尚未做任何更改。已请求客户审批将您添加为其兽医（如有宠物，也将一并添加）。',
      approval_email_sent: '审批邮件已发送给客户。该请求30天后过期。',
      approval_email_failed: '请求已记录，但审批邮件发送失败。请客户稍后查看或联系客服。',
      approval_pending: '您已有一个针对该客户的待审批请求，请等待客户通过邮件审批。',
      already_linked: '您已与该客户建立关联，且未请求添加宠物。',
      not_authorized: '只有兽医可以登记客户。',
      error_name_required: '客户姓名为必填项（至少2个字符）。',
      error_email_invalid: '请输入有效的邮箱地址。',
      error_note_empty: '就诊笔记不能为空。',
      error_generic: '登记客户失败，请重试。',
      error_network: '网络错误。请检查网络连接后重试。',
    },
    owners: {
      title: '客户',
      total_count: '共 %{count} 位客户',
      total_summary: '共 %{count} 位客户 · %{active} 位已激活 · %{pending} 位待确认',
      pets_count: '宠物',
      devices_count: '设备',
      status: '状态',
      status_active: '已激活',
      status_pending: '待确认',
      status_disabled: '已停用',
      no_owners_yet: '尚未创建任何客户。',
      select_owner: '选择一位客户以查看其患者和设备',
      phone: '电话',
      created: '创建时间',
      invitation_label: '邀请状态',
      invitation_awaiting: '等待客户确认',
      invitation_sent_on: '邀请已于 %{date} 发送 · 等待确认',
      invitation_confirmed: '已确认',
      no_pets_yet: '尚未为该客户创建宠物。',
      no_devices_yet: '尚未关联设备。',
      device_active: '已激活',
      device_inactive: '未激活',
      resend_invite: '重新发送邀请',
      resend_success: '邀请邮件已重新发送给客户。',
      resend_already_active: '该客户已确认账号。',
      resend_rate_limited: '重新发送次数过多，请稍后再试。',
      resend_error: '无法重新发送邀请，请重试。',
    },
    leads: {
      title: 'Adapet 2026 线索',
      subtitle: '汇总来自 VMX、WVC 和 Fetch Charlotte 邮件附件的会展线索。',
      total_records: '线索总数',
      unique_emails: '唯一邮箱数',
      sources: '线索来源',
      filtered_records: '筛选结果',
      search_placeholder: '按线索、公司、邮箱、角色或来源搜索',
      all_events: '全部活动',
      empty_state: '当前筛选条件下没有匹配的线索。',
      access_denied: '只有站点管理员可以查看导入的营销线索。',
    },
    profile: {
      title: '个人资料',
      profile_with_info: '个人资料：%{name} (ID: %{id})',
      my_profile: '我的个人资料',
      edit_profile: '编辑个人资料',
      name: '姓名',
      id: 'ID',
      email: '电子邮箱',
      phone: '电话',
      clinic: '诊所',
      field_clinic_name: '诊所名称',
      field_address: '地址',
      field_postal_code: '邮编',
      field_city: '城市',
      field_state: '州 / 省',
      field_country: '国家',
      country_us: '美国',
      country_ca: '加拿大',
      validation_state_invalid: '请选择有效的州或省',
      field_short_description: '简短介绍',
      field_full_profile: '完整资料',
      placeholder_short_description: '简要描述您的诊所服务',
      placeholder_full_profile: '详细描述您的兽医诊所、服务和专业领域',
      not_set: '未设置',
      qr_code: '二维码',
      qr_code_clinic_label: '宠物主人使用的诊所代码：%{id}',
      glucose_unit: '血糖单位',
      glucose_unit_mmol: 'mmol/L',
      glucose_unit_mgdl: 'mg/dL',
      validation_name_required: '姓名为必填项',
      validation_phone_invalid: '请输入有效的电话号码（10-15 位数字）',
      validation_postal_invalid: '请输入有效的邮编',
      profile_updated: '个人资料更新成功',
      profile_update_failed: '个人资料更新失败',
      glucose_unit_saved: '血糖单位偏好已保存',
      glucose_unit_save_failed: '保存血糖单位偏好失败',
      cancel: '取消',
      save: '保存',
      saving: '保存中...',
      print: '打印',
      ok: '确定',
    },
    metrics: {
      filters: {
        device: '设备',
        timestamp_gte: '时间戳 ≥',
        timestamp_lte: '时间戳 ≤',
        glucose_gte: '血糖 ≥',
        glucose_lte: '血糖 ≤',
      },
    },
    key_findings: {
      title: '关键临床发现',
      severity: {
        high: '高',
        medium: '中',
        info: '提示',
      },
      review_label: '建议复查',
      low_glucose: {
        title_significant: '低血糖读数可能需要复查',
        title_detected: '记录到低血糖读数',
        what_significant:
          '所选报告期内有 %{count} 条读数低于 %{threshold} %{unit}（低于目标范围时间 %{tbr}%）。',
        what_detected:
          '所选报告期内记录到低于目标范围（%{threshold} %{unit}）的读数（低于目标范围时间 %{tbr}%）。',
        why: '低血糖读数可能涉及患者安全问题，应结合胰岛素、进食及临床背景一并复查。',
        review: '复查低血糖时段与胰岛素注射、进食时间的对应关系，并用血糖仪确认。',
        related: '参见低血糖事件',
        related_pdf: '参见第 6 页：事件与备注',
      },
      no_low_events: {
        title: '未检测到低血糖事件',
        what: '所选报告期内未检测到低于低血糖阈值（%{threshold} %{unit}）的读数。',
        why: '该结论仅适用于所选时间窗内的已记录数据，不能排除窗口之外发生低血糖的可能。',
        review: '如临床症状提示低血糖、或读数与临床表现不符，请用血糖仪确认。',
        related: '参见低血糖事件',
        related_pdf: '参见第 6 页：事件与备注',
      },
      data_quality: {
        title_adequate: '所选时段数据覆盖充分',
        title_moderate: '所选时段数据质量中等',
        title_limited: '所选时段数据质量有限',
        title_poor: '所选时段数据质量有限',
        what: '%{start} 至 %{end} 的数据覆盖率为 %{coverage}%（共 %{readings} 条读数）。',
        why_adequate: '相关发现仅应在所选报告期内解读。',
        why_low: '传感器数据缺口会降低模式解读的可信度，可能遗漏高血糖或低血糖读数。',
        review_adequate: '仅在所选报告期范围内解读相关发现。',
        review_low: '检查传感器佩戴位置，如临床需要可考虑延长监测时间。',
        related: '参见每日指标',
        related_pdf: '参见每日概览部分',
      },
      owner_events_missing: {
        title: '缺少客户活动记录',
        what: '所选报告期内未记录任何胰岛素、进食、用药、症状或活动事件。',
        why: '缺少客户记录时，无法将血糖变化与胰岛素时间、进食或临床事件建立对应关系。',
        review: '请客户在下一个监测周期记录胰岛素、进食、用药和症状。',
        related: '参见每日趋势与活动',
        related_pdf: '参见第 5 页：每日趋势',
      },
      tar: {
        title_predominant: '以高血糖为主',
        title_elevated: '高于目标范围暴露偏高',
        title_moderate: '高于目标范围暴露中等',
        what: '所选报告期内高于目标范围的时间为 %{tar}%。',
        why: '持续高于目标的血糖可能提示记录时段内血糖控制不足。',
        review: '复查胰岛素时间、给药安排、进食时间、客户依从性及并发疾病。',
        related: '参见血糖趋势与每日TIR',
        related_pdf: '参见第 2 页：血糖趋势 与 第 3 页：每日概览',
      },
      tir: {
        title_majority: '大部分时间处于目标范围内',
        title_moderate: '目标范围内时间中等',
        title_limited: '目标范围内时间有限',
        title_very_limited: '目标范围内时间非常有限',
        what: '按所选目标范围 %{min}-%{max} %{unit} 计算，目标范围内时间为 %{tir}%。',
        why: '目标范围内时间（TIR）反映所选报告期内的整体血糖控制水平。',
        review: '与该患者既往监测周期及治疗目标进行对比。',
        related: '参见每日TIR',
        related_pdf: '参见第 3 页：每日概览',
      },
      variability: {
        title: '血糖波动性高',
        what: '所选报告期内 CV 为 %{cv}%，标准差为 %{sd} %{unit}。',
        why: '高波动性提示血糖大幅起伏，可能与日常规律不一致或事件漏记有关。',
        review: '复查进食规律、胰岛素时间、活动情况及客户依从性。',
        related: '参见AGP与每日趋势',
        related_pdf: '参见第 4 页：AGP 与 第 5 页：每日趋势',
      },
      peak_nadir: {
        title: '血糖峰值达 %{peak} %{unit}',
        what: '最高记录血糖为 %{peak} %{unit}（%{peakTime}）；最低为 %{nadir} %{unit}（%{nadirTime}）。',
        why: '极值标示所选报告期内血糖暴露的上下边界。',
        why_no_events: '没有客户记录的胰岛素或进食事件可用于解释这些极值。',
        review: '将峰值与最低值的时间与胰岛素注射、进食及客户备注进行对照复查。',
        related: '参见血糖趋势',
        related_pdf: '参见第 2 页：血糖趋势',
      },
    },
    cgm_insights: {
      title: '供兽医复查的关键 CGM 数据洞察',
      subtitle: '辅助性 CGM 数据 · 供兽医复查',
      summary_label: '所选周期数据摘要',
      disclaimer:
        '仅供兽医复查。CGM 数据为辅助性监测数据，应结合临床体征、病史、胰岛素与进食记录、客户备注，并在适当时结合确认性血糖检测一并解读。诊断与治疗决策仍由主诊兽医负责。',
      review_prefix: '供兽医复查',
      see_prefix: '参见',
      // 与计数型主数值并排显示的单位词，避免读数条数被误读为血糖值
      // （Faithfull Friends 反馈，2026-08-18）。
      readings_suffix: '条读数',
      groups: {
        needs_review: '需复查',
        needs_review_subtitle: '可能需要兽医复查的数据规律。',
        monitoring: '监测背景',
        data_quality: '数据质量',
      },
      summary: {
        lead: '在所选报告周期内，患者 %{pet} 的 CGM 数据显示',
        lead_generic: '在所选报告周期内，CGM 数据显示',
        tar_moderate: '中度的高于目标血糖暴露',
        tar_high: '较高的高于目标血糖暴露',
        variability_high: '较高的血糖变异性',
        peak: '一次高于 %{peak} %{unit} 的传感器记录血糖峰值',
        no_low: '本周期内未记录到低血糖读数。',
        low: '本周期内记录到 %{count} 次低于 %{threshold} %{unit} 的传感器低血糖读数。',
        coverage_adequate: '数据覆盖率充分',
        coverage_limited: '数据覆盖率有限',
        days_limited: '，但解读仅限于 %{days} 个有效数据天。',
        days_ok: '。',
      },
      tar: {
        title: '高于目标血糖暴露',
        key_label: '高于所选目标范围',
        meaning: '在所选报告周期内，约 %{tar}% 的时间血糖高于所选目标范围。',
        review: '复查胰岛素方案、进食时间、客户依从性、并发疾病及相关客户备注。',
        see: '血糖趋势 / 每日 TIR',
      },
      peak: {
        title: '高于 %{peak} %{unit} 的传感器记录血糖峰值',
        key_label: '%{unit} · 传感器记录峰值',
        sub_label: '峰值时间',
        meaning: '这是所选周期内最高的传感器记录血糖值。',
        review:
          '将峰值时间与胰岛素注射、进食、临床体征、客户备注对照；如临床需要，结合确认性血糖检测。',
        see: '血糖趋势',
      },
      variability: {
        title: '高血糖变异性规律',
        key_label: 'CV',
        sub_label: 'SD',
        meaning: '所选周期内血糖值波动较大。',
        review: '复查进食一致性、胰岛素时间、活动量、遗漏事件及客户记录的背景信息。',
        see: 'AGP / 每日趋势',
      },
      low_glucose: {
        title: '记录到低血糖读数',
        key_label: '低于 %{threshold} %{unit}',
        meaning: '所选周期内检测到低于目标范围的传感器记录读数。',
        review: '将低读数时间与胰岛素注射及进食对照；结合血糖检测确认。',
        see: '低血糖事件',
      },
      owner_events_missing: {
        title: '无客户记录的事件',
        key_label: '客户记录事件',
        meaning: '所选周期内未记录任何胰岛素、进食、用药、症状或活动事件。',
        review: '请客户在下一监测周期内记录胰岛素、进食、用药、症状及相关活动。',
        see: '每日趋势与活动',
      },
      tir: {
        title: '目标范围内时间',
        key_label: '处于 %{min}–%{max} %{unit}',
        meaning: '目标范围内时间概括了本报告周期内处于所选目标范围内的血糖暴露情况。',
        review: '结合高/低暴露、变异性、临床体征及兽医为该患者设定的个体化目标一并解读。',
        see: '每日 TIR',
      },
      no_low_events: {
        title: '未记录低血糖读数',
        key_label: '低于 %{threshold} %{unit}',
        meaning:
          '在该所选窗口内未记录到低于 %{threshold} %{unit} 的传感器读数。这并不排除记录周期外的低血糖或 CGM 数据未捕捉到的症状。',
        review: '如临床体征提示低血糖或 CGM 读数与患者状况不符，请结合血糖检测确认。',
        see: '低血糖事件',
      },
      data_quality: {
        title: '数据覆盖充分',
        title_limited: '数据覆盖有限',
        key_label: '覆盖率 · %{readings} 条读数',
        sub_label: '有效数据天',
        days_value: '%{days} 天',
        meaning: '各项发现仅应在所选报告周期内进行解读。',
      },
    },
    reports: {
      export_csv: '导出CSV',
      truncated_warning:
        '该时间范围内的部分读数未能全部加载，导出内容可能不完整。请缩小日期范围以获取完整数据。',
      csv_load_error: '无法加载该时间范围的读数，暂无法导出。请刷新页面或重试。',
      daily_glucose_range: '每日血糖范围',
      daily_glucose_lines: '每日血糖曲线',
      daily_glucose_histograms: '每日血糖直方图',
      combined_glucose_histogram: '综合血糖直方图',
      axis_labels: {
        glucose: '血糖',
        date: '日期',
        time_of_day: '一天中的时间',
        count: '计数',
      },
      chart_series: {
        daily_glucose: '每日血糖',
        daily_avg: '日均值',
      },
      hover_labels: {
        min: '最小值',
        max: '最大值',
        avg: '平均值',
      },
    },
    export_selection: {
      by_device: '按传感器',
      by_device_hint: '勾选一个或多个传感器，报告将恰好覆盖其佩戴期间。',
      custom_range: '自定义日期范围',
      loading_devices: '正在加载传感器…',
      devices_error: '无法加载传感器列表，请改用自定义日期范围。',
      no_devices: '未找到该患者的传感器读数。',
      no_readings: '无读数',
      short_wear: '<3 天',
      short_wear_hint: '该传感器的数据不超过 3 天。',
      days_worn: '%{smart_count} 天',
      select_one: '请至少选择一个传感器。',
      report_window: '报告时间范围',
      clamped_hint: '已限制在该患者的数据范围内（%{start} – %{end}）。',
      csv_dialog_title: '导出CSV',
    },
    pdf: {
      generate_report: '生成报告',
      preparing: '正在准备报告「…」',
      capturing: '正在准备图表「…」',
      generating: '正在准备报告「…」',
      complete: '报告已就绪',
      status_description: {
        preparing: '准备报告数据',
        capturing: '正在准备图表视觉',
        generating: '正在创建报告文档',
      },
      select_date_range: '选择报告日期范围',
      quick_presets: '快速预设',
      last_7_days: '最近7天',
      last_14_days: '最近14天',
      last_30_days: '最近30天',
      last_90_days: '最近90天',
      report_period: '报告期间',
      days: '天',
      pet_aggregated_notice: '报告将包含与此宠物关联的所有设备的数据。',
      no_data_warning: '所选日期范围内没有可用的血糖数据。',
      actual_data_range: '数据可用范围',
      use_actual_range: '使用数据范围',
      checking_data: '正在检查可用数据…',
      report_load_error: '无法加载该时间段的读数或病历记录，报告暂不可用。请刷新页面或重试。',
      empty_confirm_title: '所选范围内没有数据',
      empty_confirm_message: '所选日期范围内没有血糖读数，报告可能不包含血糖图表或指标。',
      empty_confirm_no_data: '该患者目前还没有任何血糖读数，在有数据之前报告无法包含血糖指标。',
      generate_anyway: '在没有血糖数据的情况下继续',
    },
    // 兽医CGM报告翻译（6页格式）
    vet_report: {
      title: 'Adapet CGM 兽医报告',
      report_overview: '报告概览',
      glucose_control_summary: '血糖控制摘要',
      key_findings: '主要发现',
      tir_statistics: 'TIR 统计',
      time_in_ranges: '各范围时间',
      target_range: '目标范围',
      time_in_range_tir: '目标范围时间 (TIR)',
      time_below_range_tbr: '低于目标时间 (TBR)',
      time_above_range_tar: '高于目标时间 (TAR)',
      average_glucose: '平均血糖',
      data_coverage: '数据覆盖率',
      range: '范围',
      percent: '%',
      time: '时间',
      // 第2页：AGP
      agp: 'AGP',
      ambulatory_glucose_profile: '动态血糖谱 (AGP)',
      pattern_summary: '模式摘要',
      time_block: '时间段',
      median: '中位数',
      iqr: 'IQR (25-75)',
      comment: '备注',
      // 第3页：血糖趋势
      glucose_trend: '血糖趋势',
      glucose_trend_window: '血糖趋势（报告窗口）',
      target_range_band_note: '图表范围基于所选的血糖显示设置。',
      notable_segments: '值得注意的段落及标注',
      date_time: '日期/时间',
      type: '类型',
      value: '数值',
      notes_column: '备注',
      no_notable_segments: '此期间未检测到值得注意的段落。',
      // 第4页：每日概览
      daily_overview: '每日概览',
      daily_time_in_ranges: '每日各范围时间',
      daily_metrics: '每日指标',
      date: '日期',
      avg: '均值',
      min_max: '最小-最大',
      tir: 'TIR',
      tar: 'TAR',
      tbr: 'TBR',
      readings: '读数',
      activities_column: '活动',
      // 第5页：每日趋势
      daily_trends: '每日趋势',
      no_daily_data: '所选期间没有可用的每日数据。',
      no_activities_recorded: '未记录活动',
      // 第6页：事件与笔记
      events_and_notes: '事件与笔记',
      low_glucose_events: '低血糖事件（低于阈值）',
      events_disclaimer: '事件为低于配置阈值的传感器读数。请结合临床情况进行解读。',
      glucose_mmol: '血糖',
      severity: '严重程度',
      no_low_events: '此期间未检测到低血糖事件。',
      veterinary_assessment: '兽医复核备注',
      clinician: '临床医师',
      // 页脚
      footer_disclaimer: '为兽医审查生成。请在临床背景下解读；必要时通过确认性检测进行验证。',
      page_of: '第 %{page} 页，共 %{total} 页',
    },
  },
  resources: {
    customers: {
      name: '客户 |||| 客户',
      fields: {
        orders: '订单',
        first_seen: '首次见到',
        full_name: '姓名',
        groups: '分组',
        last_seen: '最后见到',
        last_seen_gte: '访问自',
        name: '姓名',
        total_spent: '设备总支出',
        password: '密码',
        confirm_password: '确认密码',
        stateAbbr: '州',
      },
      filters: {
        last_visited: '最后访问',
        today: '今天',
        this_week: '本周',
        last_week: '上周',
        this_month: '本月',
        last_month: '上月',
        earlier: '更早',
        has_ordered: '已订购',
        has_newsletter: '有新闻简报',
        group: '分组',
      },
      fieldGroups: {
        identity: '身份',
        address: '地址',
        stats: '统计',
        history: '历史',
        password: '密码',
        change_password: '更改密码',
      },
      page: {
        delete: '删除客户',
      },
      errors: {
        password_mismatch: '确认密码与密码不匹配。',
      },
      notifications: {
        created: '客户已创建 |||| %{smart_count} 个客户已创建',
        updated: '客户已更新 |||| %{smart_count} 个客户已更新',
        deleted: '客户已删除 |||| %{smart_count} 个客户已删除',
      },
    },
    groups: {
      name: '护理团队 |||| 护理团队',
      fields: {
        name_helper: '为您的兽医群组选择一个唯一的名称',
        description_helper: '描述此群组的用途（可选）',
      },
      notifications: {
        created: '群组创建成功',
        updated: '群组更新成功',
        consent_update_failed: '更新同意状态失败',
        members_load_failed: '加载成员失败',
        email_required: '请输入邮箱地址',
        group_id_missing: '缺少群组 ID',
        invite_failed: '发送邀请失败',
        member_removed: '成员已成功移除',
        member_remove_failed: '移除成员失败',
      },
      errors: {
        forbidden: '您没有权限执行此操作',
        create_failed: '创建群组失败。请重试。',
        no_create_permission: '您没有权限创建群组。只有兽医管理员可以创建群组。',
      },
      ui: {
        invitations: '群组邀请',
        empty_title: '暂无护理团队。',
        empty_readonly:
          '您的诊所无需使用协作团队。诊所在“诊所团队”中自行管理兽医，并可通过“宠物分享”与同事共享患者。',
        empty_use_clinic_team: '为每位兽医创建子账户并分配患者，让提醒发送给负责的兽医：',
        invitation_pending: '群组邀请待处理',
        invitation_pending_desc: '您已被邀请加入此群组。请接受或拒绝。',
        accept: '接受',
        decline: '拒绝',
        declined: '已拒绝',
        cancel: '取消',
        administrators: '管理员',
        unknown: '未知',
        loading: '加载中…',
        invite_member: '邀请成员',
        invite_new_member: '邀请新成员',
        email_address: '邮箱地址',
        remove_member_confirm: '确定要移除此成员吗？',
        group_members: '群组成员',
        read_only: '（只读）',
        send_invitation: '发送邀请',
        sending: '发送中…',
        col_group: '群组',
        col_invited_by: '邀请人',
        col_invited_date: '邀请日期',
        col_invited_at: '邀请时间',
        col_status: '状态',
        col_actions: '操作',
        col_email: '邮箱',
        col_user: '用户',
      },
    },
    orders: {
      name: '订单 |||| 订单',
      amount: '1 个订单 |||| %{smart_count} 个订单',
      title: '订单 %{reference}',
      fields: {
        basket: {
          delivery: '配送',
          reference: '参考',
          quantity: '数量',
          sum: '总计',
          tax_rate: '税率',
          taxes: '税费',
          total: '总计',
          unit_price: '单价',
        },
        address: '地址',
        customer_id: '客户',
        date_gte: '开始时间',
        date_lte: '结束时间',
        nb_items: '项目数量',
        total_gte: '最小金额',
        status: '状态',
        returned: '已退货',
      },
      section: {
        order: '订单',
        customer: '客户',
        shipping_address: '配送地址',
        items: '项目',
        total: '总计',
      },
      notifications: {
        created: '订单已创建 |||| %{smart_count} 个订单已创建',
        updated: '订单已更新 |||| %{smart_count} 个订单已更新',
        deleted: '订单已删除 |||| %{smart_count} 个订单已删除',
      },
    },
    invoices: {
      name: '发票 |||| 发票',
      fields: {
        date: '发票日期',
        customer_id: '客户',
        order_id: '订单',
        date_gte: '开始时间',
        date_lte: '结束时间',
        total_gte: '最小金额',
        address: '地址',
      },
      notifications: {
        created: '发票已创建 |||| %{smart_count} 个发票已创建',
        updated: '发票已更新 |||| %{smart_count} 个发票已更新',
        deleted: '发票已删除 |||| %{smart_count} 个发票已删除',
      },
    },
    products: {
      name: '商品 |||| 商品',
      fields: {
        category_id: '类别',
        height_gte: '最小高度',
        height_lte: '最大高度',
        height: '高度',
        image: '图片',
        price: '价格',
        reference: '参考',
        sales: '销售',
        stock_lte: '库存不足',
        stock: '库存',
        thumbnail: '缩略图',
        width_gte: '最小宽度',
        width_lte: '最大宽度',
        width: '宽度',
      },
      tabs: {
        image: '图片',
        details: '详情',
        description: '描述',
        emrs: 'EMRs',
      },
      filters: {
        categories: '类别',
        stock: '库存',
        no_stock: '缺货',
        low_stock: '1 - 9 项',
        average_stock: '10 - 49 项',
        enough_stock: '50 项及以上',
        sales: '销售',
        best_sellers: '最佳销售',
        average_sellers: '平均',
        low_sellers: '低',
        never_sold: '从未售出',
      },
      notifications: {
        created: '商品已创建 |||| %{smart_count} 个商品已创建',
        updated: '商品已更新 |||| %{smart_count} 个商品已更新',
        deleted: '商品已删除 |||| %{smart_count} 个商品已删除',
      },
    },
    categories: {
      name: '类别 |||| 类别',
      fields: {
        products: '商品',
      },
      notifications: {
        created: '类别已创建 |||| %{smart_count} 个类别已创建',
        updated: '类别已更新 |||| %{smart_count} 个类别已更新',
        deleted: '类别已删除 |||| %{smart_count} 个类别已删除',
      },
    },
    owners: {
      name: '客户 |||| 客户',
      amount: '1 位客户 |||| %{smart_count} 位客户',
    },
    leads: {
      name: '线索 |||| 线索',
      amount: '1 条线索 |||| %{smart_count} 条线索',
      fields: {
        event: '活动',
        name: '线索',
        email: '邮箱',
        company: '公司',
        role: '角色',
        location: '地区',
        context: '上下文',
        captured_at: '采集时间',
      },
    },
    pets: {
      // Clinic filter on the Pets list (internal / support view).
      clinic_filter: {
        chip: '诊所：%{name}',
        best_effort: '已改为显示尽力匹配的结果。',
        load_failed: '加载关联宠物失败。',
        mismatch_title: '检测到数据不一致',
        mismatch_body:
          '诊所显示有 %{linked} 只关联宠物，但只找到 %{found} 条宠物记录。这通常意味着某只关联宠物已归档，或其访问策略使其在此视图中不可见。请联系支持人员核对宠物 ID 列表。',
        sources: '来源：直属=%{direct}，兽医关联=%{vets}，诊所共享=%{share}，患者共享=%{specific}',
        none_linked: '没有宠物关联到此诊所。',
      },
      // Chronic-condition choices on the pet edit form (the stored value is the code).
      conditions: {
        diabetes: '糖尿病',
        kidney_disease: '慢性肾病',
        hyperthyroidism: '甲状腺功能亢进',
        hypothyroidism: '甲状腺功能减退',
        obesity: '肥胖',
        arthritis: '骨关节炎',
        heart_disease: '心脏病',
        cushings: '库欣综合征',
        addisons: '艾迪生病',
        epilepsy: '癫痫',
        other: '其他',
      },
      name: '宠物 |||| 宠物',
      amount: '1 只宠物 |||| %{smart_count} 只宠物',
      detail: '宠物详情',
      search_placeholder: '按宠物名称 / 宠主 / 品种 / 物种 / ID搜索',
      fields: {
        id: 'ID',
        name: '宠物名称',
        owner: '客户',
        co_owners: '应用用户',
        pet_name: '宠物名称',
        dob: '出生日期',
        birthday: '生日',
        created: '创建时间',
        owner_email: '客户邮箱',
        owner_website: '客户网站',
        species: '物种',
        breed: '品种',
        height: '身高',
        weight: '体重',
        sex: '性别',
        color: '颜色',
        createdAt: '创建时间',
        updatedAt: '更新时间',
        sensor_activated: '传感器激活时间',
        vet_account: '兽医账号',
        vet_account_not_bound: '未绑定兽医账号',
        assigned_vet: '负责兽医',
        data_status: '数据状态',
        weight_kg: '体重（千克，精确值）',
        neutered: '已绝育',
        hide_glucose_values: '向宠物主人隐藏血糖数值',
        birth_date: '出生日期（精确）',
        body_condition_score: '身体状况评分（1-9）',
        chronic_conditions: '慢性疾病',
        condition_code: '疾病',
        condition_diagnosed_on: '确诊日期',
        condition_notes: '备注',
        target_glucose_low: '目标血糖下限 (mg/dL)',
        target_glucose_high: '目标血糖上限 (mg/dL)',
        target_kcal_in_override: '兽医热量目标（千卡/天，可选覆盖值）',
      },
      data_status: {
        active: '正常',
        waiting_sync: '等待同步',
        no_sensor: '无传感器',
        data_error: '暂无最新数据',
        expired: '传感器已过期',
        archived: '已归档',
      },
      data_status_tooltip: {
        active: '已接收到最新的 CGM 读数。',
        waiting_sync: '传感器已配对，等待首次同步。',
        no_sensor: '尚未连接 CGM 设备 — 请配对传感器以开始采集数据。',
        data_error: '超过 24 小时没有读数 — 传感器可能已到期脱落，或与手机断开连接。',
        expired: '该传感器已达到 14 天佩戴寿命上限。请更换传感器以恢复监测。',
        archived: '宠物记录已归档。',
      },
      data_status_alert: {
        no_sensor: {
          title: '未找到该宠物的活跃 CGM 会话。',
          body: '该宠物尚未连接 CGM 设备。请配对传感器以开始采集血糖读数。',
          action: '配对传感器',
        },
        waiting_sync: {
          title: '传感器已连接，等待数据同步。',
          body: '%{smart_count} 个传感器已配对，但尚未上传读数。CGM 设备通常在激活后一小时内发送第一批数据。',
        },
        data_error: {
          title: '传感器数据已停滞。',
          body: '最后一次读数在 24 小时前。请确保设备已连接，如果问题持续，请联系支持。',
        },
        expired: {
          title: '传感器已过期——请更换传感器',
          body: '该传感器已达到 14 天佩戴寿命上限，已停止采集新的读数。请更换新的传感器以恢复监测。',
          action: '更换传感器',
        },
        archived: {
          title: '该宠物记录已归档。',
          body: '已归档的宠物会保留历史数据，但不再采集新的读数。',
        },
        devices_load_failed: {
          title: '传感器信息未能加载。',
          body: '加载完成前，传感器和数据状态信息会缺失，患者可能不会显示其已有的传感器。请刷新页面重试。',
        },
        device_data_unavailable: {
          title: '您的账号当前无法查看设备数据。',
          body: '该宠物已关联设备，但您的会话看不到任何读数。请刷新页面；如果问题持续，可能需要恢复您账号的数据访问权限，请联系支持。',
        },
        load_timeout: {
          title: '此页面加载时间超出预期。',
          body: '这几乎总是因为您的浏览器正在运行较旧的缓存版本 VetPo。请重新加载以获取最新版本——这通常会立即恢复图表。如果问题持续出现，请联系支持。',
          action: '重新加载 VetPo',
        },
      },
      sex_options: {
        male: '雄性',
        female: '雌性',
        neutered_male: '已绝育雄性',
        spayed_female: '已绝育雌性',
        unknown: '未知',
      },
      species_options: {
        dogs: '犬',
        cats: '猫',
        horses: '马',
        cows: '牛',
        rabbits: '兔',
        guinea_pigs: '豚鼠',
        ferrets: '雪貂',
      },
      action: {
        accept: '接受',
        reject: '拒绝',
      },
      hide: {
        action: '从我的列表中隐藏',
        confirm_title: '要从您诊所的患者列表中隐藏该患者吗？',
        confirm_body:
          '此操作仅将%{pet}从您诊所的患者列表中移除。宠物主人及其他诊所仍可正常查看该记录——不会删除任何数据。',
        success: '%{pet}已从您的列表中隐藏。',
        undo: '撤销',
        undo_success: '患者已恢复到您的列表中。',
        error: '无法更新该患者的隐藏状态，请重试。',
        show_hidden_toggle: '显示已隐藏',
        hidden_chip: '已隐藏',
        unhide_action: '取消隐藏',
        hidden_list_empty: '没有已隐藏的患者。',
        hidden_list_error: '无法加载已隐藏的患者，请重试。',
        hidden_list_col_pet: '患者',
        hidden_list_col_owner: '客户',
        hidden_list_col_hidden_at: '隐藏时间',
        hidden_list_col_hidden_by: '隐藏人',
        hidden_list_col_actions: '操作',
      },
    },
    activities: {
      name: '活动 |||| 活动',
      amount: '1 个活动 |||| %{smart_count} 个活动',
      detail: '活动详情',
      fields: {
        id: 'ID',
        name: '名称',
        owner: '客户',
        pet: '宠物',
        pet_id: '宠物ID',
        type: '类型',
        start_time: '开始时间',
        end_time: '结束时间',
        time: '持续时间',
        duration: '持续时间',
        description: '描述',
        created_at: '创建时间',
        updated_at: '更新时间',
      },
      insulin: {
        label: '胰岛素',
        brand: '品牌',
        custom_brand: '自定义品牌',
        dosage: '剂量',
        units: '单位',
      },
      action: {
        accept: '接受',
        reject: '拒绝',
      },
    },
    devices: {
      all_devices_pet: '🔗 全部设备（该患者）',
      devices_count: '%{smart_count} 台设备',
      pet_id: '患者 ID：%{id}',
      name: '设备 |||| 设备',
      amount: '1 个设备 |||| %{smart_count} 个设备',
      detail: '设备详情',
      fields: {
        id: 'ID',
        name: '名称',
        owner: '客户',
        pet: '宠物',
        type: '类型',
        start_time: '开始时间',
        glucose_trend: '血糖趋势',
        timezone: '时区',
        createdAt: '创建时间',
        updatedAt: '更新时间',
      },
      action: {
        accept: '接受',
        reject: '拒绝',
      },
    },
    metrics: {
      name: '读数 |||| 读数',
      amount: '1 个读数 |||| %{smart_count} 个读数',
      detail: '读数详情',
      fields: {
        id: 'ID',
        name: '名称',
        owner: '客户',
        device: '设备',
        offset: '偏移量',
        timestamp: '时间戳',
        // Raw-data list: STORED (QR) value, uncorrected — see en.ts note.
        glucose: '血糖（原始值）',
        glucose_display: '血糖（显示值）',
        createdAt: '创建时间',
        updatedAt: '更新时间',
      },
      action: {
        accept: '接受',
        reject: '拒绝',
      },
    },
    emrs: {
      name: '病历 |||| 病历',
      amount: '1 个病历 |||| %{smart_count} 个病历',
      detail: '病历详情',
      fields: {
        id: 'ID',
        pet: '宠物',
        pet_id: '宠物ID',
        vet: '兽医',
        notes: '备注',
        number: '#',
        author: '作者',
        content: '内容',
        timestamp: '日期',
        date: '日期',
        created: '创建时间',
        updated: '更新时间',
        createdAt: '创建时间',
        updatedAt: '更新时间',
      },
      action: {
        accept: '接受',
        reject: '拒绝',
        add_note: '添加病历',
      },
      notifications: {
        created: '病历已创建 |||| %{smart_count} 个病历已创建',
        updated: '病历已更新 |||| %{smart_count} 个病历已更新',
        deleted: '病历已删除 |||| %{smart_count} 个病历已删除',
        approved_success: '病历已批准',
        approved_error: '错误：病历未批准',
        rejected_success: '病历已拒绝',
        rejected_error: '错误：病历未拒绝',
      },
    },
    foods: {
      name: '食物',
      fields: {
        brand: '品牌',
        productName: '产品名称',
        species: '适用物种',
        form: '形态',
        displayName: '显示名称',
        kcalPerGram: '千卡/克',
        proteinPercent: '蛋白质 %',
        fatPercent: '脂肪 %',
        carbohydratePercent: '碳水化合物 %',
        fiberPercent: '纤维 %',
        moisturePercent: '水分 %',
        glycemicIndex: '升糖指数',
        diabeticFriendly: '适合糖尿病',
        isActive: '启用',
        sourceUrl: '来源链接（厂商页面）',
        notes: '备注',
        protein: '蛋白质 %',
        carb: '碳水 %',
        gi: '升糖指数',
      },
      sections: {
        identity: '基本信息',
        energy: '能量密度',
        macros: '常量营养素（喂食状态 %）',
        diabetes: '糖尿病相关',
        admin: '目录管理',
      },
      helpers: {
        display_name: "可选覆盖 — 默认为 '{brand} — {productName}'",
        kcal_per_gram: '每克食物（喂食状态）的千卡数',
        kcal_per_gram_detail: '每克食物（喂食状态）的千卡数（干粮通常 3.5-4.5；湿粮 0.8-1.2）',
        glycemic_index: '0-100 升糖指数估值（数值越低越适合糖尿病患宠）',
        diabetic_friendly: '低升糖、低碳水，兽医推荐用于糖尿病宠物',
      },
      species: {
        dog: '犬',
        cat: '猫',
        both: '犬猫通用',
        dog_and_cat: '犬 + 猫',
      },
      form: {
        dry: '干粮',
        wet: '湿粮',
        treat: '零食',
        topper: '拌粮',
        raw: '生食',
        other: '其他',
      },
    },
    segments: {
      name: '分组 |||| 分组',
      fields: {
        customers: '客户',
        name: '群组名称',
      },
      data: {
        compulsive: '强迫性',
        collector: '收集者',
        ordered_once: '仅订购一次',
        regular: '常规',
        returns: '退货',
        reviewer: '评论者',
      },
    },
    glucose: {
      axis_labels: {
        max: '最大值',
        min: '最小值',
        glucose: '血糖',
        date: '日期',
        time: '时间',
      },
      hover_labels: {
        max: '最大值',
        min: '最小值',
      },
    },
  },
}

export default customChineseMessages
